<template>
    <b-modal
        ref="modal"
        :size="data.size || 'md'"
        :centered="data.centered || false"
        :scrollable="data.scrollable || false"
        :no-close-on-backdrop="data.noCloseOnBackdrop || true"
        :no-close-on-esc="data.noCloseOnEsc || false"
        :ok-only="true"
        :ok-title="_trans('Ok')"
        :hide-footer="status !== 2"
        @hide="hide"
        @hidden="onClose"
        @shown="onShow"
        @ok="close(1)"
    >
        <template v-slot:modal-title>
            <h5 v-if="status < 2" class="modal-title">
                <i v-if="status === 1" class="di di-arrow-left" style="cursor: pointer;" @click="status = 0"></i>
                <span v-text="_trans('Register customer')"></span>
            </h5>
            <h5 v-else class="modal-title" v-text="_trans('Customer info')"></h5>
        </template>

        <div v-if="loading" class="d-flex">
            <circle-loader class="m-auto" size="xs"></circle-loader>
        </div>

        <!--Check customer mobile-->
        <template v-if="!loading && status === 0">
            <form @submit.prevent="checkMobile()">
                <input
                    v-model="customerMobile"
                    v-focus
                    type="text"
                    class="form-control mt-3"
                    :placeholder="_trans('phone number')"
                    :disabled="customersList.length > 0"
                    @keyup="checkMobilePlus"
                />
                <div v-if="errors.length" class="text-danger" v-text="errors[errors.length-1]"></div>
                <div v-else-if="warnings.length" class="text-warning" v-text="warnings[warnings.length-1]"></div>
                <div v-else>&nbsp;</div>

                <button v-if="!customersList.length > 0" type="submit" :disabled="errors.length > 0 || !customerMobile.length " class="btn btn-primary d-flex ml-auto" v-text="_trans('Check')"></button>

                <button
                    v-if="customersList.length > 0"
                    type="button"
                    class="btn btn-primary d-flex ml-auto"
                    @click="skipToMail()"
                    v-text="_trans('none of the below')">
                </button>

                <div v-if="customersList.length > 0">
                    <ul v-for="customer in customersList" :key="customer.IdentityId" class="list-unstyled mb-0">
                        <li class="list-group-item my-2">
                            <div class="d-flex flex-row">
                                <div class="d-flex flex-column flex-grow-1 text-info">
                                    <!--<pre v-text="customer"></pre>-->
                                    <span v-if="customer.IdentityId" class="text-primary" style="font-size: x-small">
                          <span v-text="_trans('Existing identity')"></span>
                          <span v-text="customer.IdentityId"></span>
                        </span>
                                    <span v-else class="text-warning" style="font-size: x-small" v-text="_trans('No existing identity')"></span>
                                    <span v-if="customer.Email" v-text="customer.Email"></span>
                                    <span v-text="customer.LastName +' '+ customer.FirstName"></span>
                                    <span v-text="customer.MobileNumber"></span>
                                </div>
                                <div class="d-flex">
                                    <button class="btn btn-primary my-auto" @click="selectCustomer(customer)" v-text="_trans('Select')"></button>
                                </div>
                            </div>
                        </li>
                        <li v-for="sec in getSecondaiesId(customer)" :key="sec.IdentityId" class="list-group-item my-2">
                            <div class="d-flex flex-column flex-grow-1 text-info">
                                <!--<pre v-text="customer"></pre>-->
                                <span v-if="sec.IdentityId" class="text-primary" style="font-size: x-small">
                                    <span v-text="_trans('Existing identity')"></span>
                                    <span v-text="sec.IdentityId"></span>
                                </span>
                                <span v-else class="text-warning" style="font-size: x-small" v-text="_trans('No existing identity')"></span>
                                <span v-if="sec.Email" v-text="sec.Email"></span>
                                <span v-text="sec.LastName +' '+ sec.FirstName"></span>
                                <span v-if="sec.Mobile">{{ sec.Mobile.CountryCallingCode }}{{ sec.Mobile.Number }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </form>
        </template>

        <!--Check customer email-->
        <template v-else-if="!loading && status === 1">
            <form @submit.prevent="checkEmail()">
                <p
                    v-if="!customersList.length > 0"
                    class="text-info"
                    v-text="_trans('No matches were found for this number, please try searching by email:')"
                ></p>
                <input
                    v-model="customerEmail"
                    v-focus
                    type="email"
                    class="form-control mt-3"
                    :placeholder="_trans('email')"
                    :disabled="customersList.length > 0"
                />
                <div v-if="errors.length" class="text-danger" v-text="errors[errors.length-1]"></div>
                <div v-else-if="warnings.length" class="text-warning" v-text="warnings[warnings.length-1]"></div>
                <div v-else>&nbsp;</div>

                <button v-if="!customersList.length > 0" type="submit" class="btn btn-primary d-flex ml-auto" v-text="_trans('Check')"></button>

                <button
                    v-if="customersList.length > 0"
                    type="button"
                    class="btn btn-primary d-flex ml-auto"
                    @click="skipToCustomer()"
                    v-text="_trans('none of the below')">
                </button>

                <div v-if="customersList.length > 0">
                    <ul v-for="customer in customersList" :key="customer.IdentityId" class="list-unstyled mb-0">
                        <li class="list-group-item my-2">
                            <div class="d-flex flex-row">
                                <div class="d-flex flex-column flex-grow-1 text-info">
                                    <!--<pre v-text="customer"></pre>-->
                                    <span v-if="customer.IdentityId" class="text-primary" style="font-size: x-small">
                          <span v-text="_trans('Existing identity')"></span>
                          <span v-text="customer.IdentityId"></span>
                        </span>
                                    <span v-else class="text-warning" style="font-size: x-small" v-text="_trans('No existing identity')"></span>
                                    <span v-if="customer.Email" v-text="customer.Email"></span>
                                    <span v-text="customer.LastName +' '+ customer.FirstName"></span>
                                    <span v-text="customer.MobileNumber"></span>
                                </div>
                                <div class="d-flex">
                                    <button class="btn btn-primary my-auto" @click="selectCustomer(customer)" v-text="_trans('Select')"></button>
                                </div>
                            </div>
                        </li>
                        <li v-for="sec in getSecondaiesId(customer)" :key="sec.IdentityId" class="list-group-item my-2">
                            <div class="d-flex flex-column flex-grow-1 text-info">
                                <!--<pre v-text="customer"></pre>-->
                                <span v-if="sec.IdentityId" class="text-primary" style="font-size: x-small">
                                    <span v-text="_trans('Existing identity')"></span>
                                    <span v-text="sec.IdentityId"></span>
                                </span>
                                <span v-else class="text-warning" style="font-size: x-small" v-text="_trans('No existing identity')"></span>
                                <span v-if="sec.Email" v-text="sec.Email"></span>
                                <span v-text="sec.LastName +' '+ sec.FirstName"></span>
                                <span v-if="sec.Mobile">{{ sec.Mobile.CountryCallingCode }}{{ sec.Mobile.Number }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </form>
        </template>

        <!--Create/update customer-->
        <template v-else-if="!loading && status === 2">
            <div>

                <p v-if="newCustomer" v-text="_trans('No matches were found for this email, please enter the customer information:')"></p>
                <p v-else v-text="_trans('User found')"></p>

                <div v-if="customerData.IdentityId" class="row no-gutters mt-1">
                    <input v-model="customerData.IdentityId" type="text" class="form-control" :disabled="true" />
                </div>
                <div v-else>
                    <input type="text" class="form-control" :value="_trans('No existing identity')" :disabled="true" />
                </div>
                <div class="row no-gutters mt-1">
                    <input v-model="customerData.Email" type="email" class="form-control" :disabled="customerData.IdentityId" :placeholder="_trans('Email')" />
                </div>
                <div class="row no-gutters mt-1">
                    <div class="input-group">
                        <!--<div class="input-group-prepend">
                          <span class="input-group-text" v-text="dialCode"></span>
                        </div>-->
                        <input v-model="customerData.MobileNumber" type="text" class="form-control" :placeholder="_trans('phone')" />
                    </div>
                </div>
                <div class="row no-gutters mt-1">
                    <input v-model="customerData.FirstName" type="text" class="form-control" :placeholder="_trans('First name')" />
                </div>
                <div class="row no-gutters mt-1">
                    <input v-model="customerData.LastName" type="text" class="form-control" :placeholder="_trans('Last name')" />
                </div>
                <div v-if="customerData.Address">
                    <!--<div class="row no-gutters mt-1">
                      <input type="text" class="form-control" v-model="customerData.Address.CO" :placeholder="_trans('CO')" />
                    </div>-->
                    <div class="row no-gutters mt-1">
                        <input v-model="customerData.Address.Street" type="text" class="form-control" :placeholder="_trans('Street')" />
                    </div>
                    <div class="row no-gutters mt-1">
                        <div class="col">
                            <input v-model="customerData.Address.PostalCode" type="text" class="form-control" :placeholder="_trans('Postal code')" />
                        </div>
                        <div class="col">
                            <input v-model="customerData.Address.PostalArea" type="text" class="form-control" :placeholder="_trans('Postal area')" />
                        </div>
                    </div>
                    <div class="row no-gutters mt-1">
                        <input v-model="customerData.Address.Country" type="text" class="form-control" :placeholder="_trans('Country')" />
                    </div>
                    <div class="row no-gutters mt-3">
                        <span v-text="_trans('Sales area')"></span>
                        <input v-model="customerData.SalesAreaCountry" type="text" class="form-control" readonly :placeholder="_trans('Country')" />
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:modal-footer>
            <button type="button" class="btn btn-primary" :disabled="!canSubmit" @click="updateAndConfirm()" v-html="_trans('Update and continue')"></button>
        </template>
    </b-modal>
</template>
<script>
import { NextApiClient } from '@3cad/nextcore';
import { ProjectsAPI }  from '@3cad/nextcore';
import { bus } from "@store/dau";
import modal from "@dialogs/modal.vue";
let E_STEP = {
    MOBILE: 0,
    EMAIL: 1,
    SAVE_CUSTOMER: 2
};

export default {
    mixins: [modal],
    components: {
        CircleLoader: () => import("@configurator/comp/circleLoader")
    },
    data() {
        return {
            status: E_STEP.MOBILE,
            loading: false,
            customerEmail: '',
            customerMobile: '+46707407874',
            customersList: [],
            customerData: {},
            createUpdate: false,
            editMail: false,
            errors: [],
            warnings: []
        }
    },
    computed: {
        preferences() {
            return this.$store.getters['getPreferences'];
        },
        chain() {
            return this.data.chainId;
        },
        dialCode() {
            if(!this.chain)
                return null;
            else
                return this.chainsData.filter( r => { return r.id === this.chain })[0].dialCode;
        },
        canSubmit() {
            if (this.customerData)
                return this.customerData.Email;
            else
                return false;
        },
        newCustomer() {
            if(this.customerData) {
                if (!this.customersList.length)
                    return !(this.customerData.Email && this.customerData.IdentityId);
                else
                    return false;
            }
            else
                return true;
        },
        countryCode() {
            let chainId = this.preferences.config.chainid;
            return this.chainsData.filter( r => { return r.id === chainId })[0].countryCode;
        },
        operatingChain() {
            let chainId = this.preferences.config.chainid;
            return this.chainsData.find( r => { return r.id === chainId }).op;
        }
    },
    methods: {
        getSecondaiesId(id) {
            if(id.SecondaryIdentities && id.SecondaryIdentities.length)
                return id.SecondaryIdentities
            else
                return []
        },
        checkMobile() {
            if(this.errors.length) {
                alert('Error')

                return
            }
            this.errors = [];
            this.warnings = [];
            if (!this.customerMobile) {
                this.errors.push(this._trans('Mobile required.'));
                return;
            }

            this.loading = true;
            this._searchIdentity({
                "PhoneNumber": this.customerMobile,
                "Country": this.countryCode
            })
                .then(json => {
                    this.loading = false;
                    if(!json.Identities || !json.Identities.length) {
                        this.status = E_STEP.EMAIL;
                        this.customerMobile = '';
                    }
                    else {
                        this.customersList = json.Identities;
                    }
                })
                .catch(err => {
                    // debugger;
                    if((new RegExp('Unvalid NEXT user', 'ig')).test(err)) {
                        NextApiClient.refreshSession().then(this.checkMobile)
                    } else {
                        console.error(err);
                        this.loading = false;
                        this.response = { error: true };
                        this.close(1);
                    }
                })
        },
        checkEmail() {
            this.errors = [];
            this.warnings = [];
            // this.customerData = {};
            if (!this.customerEmail) {
                this.errors.push(this._trans('Email required.'));
                return;
            } else if (!this._validEmail(this.customerEmail)) {
                this.errors.push(this._trans('Valid email required.'));
                return;
            }

            this.loading = true;
            this._searchIdentity({
                "Email": this.customerEmail,
                "Country": this.countryCode
            })
                .then(json => {
                    this.loading = false;
                    /*if(json.Identity) {
                        for(let k in json.Identity)
                            this.$set(this.customerData, k, json.Identity[k])
                    }
                    else {
                        this.$set(this.customerData, 'Email', this.customerEmail);
                        this.$set(this.customerData, 'Address', {});
                    }

                    this.status = E_STEP.SAVE_CUSTOMER;*/
                    if(!json.Identities || !json.Identities.length) {
                        this.status = E_STEP.SAVE_CUSTOMER;
                        this.customerData = {
                            Email: this.customerEmail,
                            SalesAreaCountry: this.countryCode,
                            OperatingChain: this.operatingChain,
                            EmployeeNumber: this.user.userName.split('@')[0],
                            Store: `${this.user.shop.cod}`
                        }

                        this.customerData.Address = {};
                        this.customerEmail = '';
                    }
                    else {
                        this.customersList = json.Identities;
                    }
                })
                .catch(err => {
                    if((new RegExp('Unvalid NEXT user', 'ig')).test(err)) {
                        NextApiClient.refreshSession().then(this.checkMobile)
                    } else {
                        console.error(err);
                        this.loading = false;
                    }
                })
        },
        /** Save customer if is missing from guestbook db
         *
         * @returns {Promise|Promise<T>}
         */
        saveCustomer(customerData) {
            return new Promise( (resolve, reject) => {
                ProjectsAPI.guestAdd(customerData, res => {
                    if (res)
                        resolve(res);
                    else
                        reject(new Error('Missing response'));
                }, reject);
            })
        },
        /** Update customer if is missing from guestbook db
         *
         * @returns {Promise|Promise<T>}
         */
        updateCustomer(customerData) {
            return new Promise( (resolve, reject) => {
                ProjectsAPI.guestChange(customerData, res => {
                    if (res)
                        resolve(res);
                    else
                        reject(new Error('Missing response'));
                }, reject);
            })
        },
        /** Close modal dialog after save and/or update customer
         *
         */
        updateAndConfirm() {
            let closeModal = () => {
                this.response = this.customerData;
                bus.$emit('stopLoading');
                this.close(1);
            };

            bus.$emit('startLoading');
            this._upsertIdentity(this.customerData)
                .then(json => {
                    this.customerData.IdentityId = json.IdentityId

                    // Check customer in 3cad services
                    let params = {email: this.customerData.Email, chainid: this.chain}

                    ProjectsAPI.guestCheck(params, res => {
                            if (res && res.extra && res.extra.indexOf('System.Collections.Generic') > -1) {
                                res.extra = ''
                            }

                            let data = {
                                address: this.customerData.Address.Street,
                                cap: this.customerData.Address.PostalCode,
                                country: this.customerData.Address.Country,
                                fullname: this.customerData.FirstName + ' ' + this.customerData.LastName,
                                password: this.customerData.IdentityId,
                                extra: this.customerData.IdentityId,
                                phone: this.customerData.MobileNumber,
                                email: this.customerData.Email,
                                chainid: this.chain
                            }

                            if (Object.keys(res).length < 1) {
                                // Create customer
                                this.saveCustomer(data)
                                    .then(this.updateCustomer)
                                    .then(closeModal)
                            } else {
                                // Update customer
                                this.updateCustomer(data)
                                    .then(closeModal)
                            }
                        },
                        err => {
                            let data = {
                                address: this.customerData.Address.Street,
                                cap: this.customerData.Address.PostalCode,
                                country: this.customerData.Address.Country,
                                fullname: this.customerData.FirstName + ' ' + this.customerData.LastName,
                                password: this.customerData.IdentityId,
                                extra: this.customerData.IdentityId,
                                phone: this.customerData.MobileNumber,
                                email: this.customerData.Email,
                                chainid: this.chain
                            }

                            // Create customer
                            this.saveCustomer(data)
                                .then(this.updateCustomer)
                                .then(closeModal)
                        })
                })
                .catch(err => {
                    this.loading = false;
                    this.response = {
                        error: err
                    };
                    this.close(1);
                })
        },
        /** Elkjop service searchIdentity
         * @param obj
         * @returns {Promise<any>}
         * @private
         */
        _searchIdentity (obj) {
            return new Promise( (resolve, reject) => {
                NextApiClient.combase(
                    this.preferences.config.mediation,
                    'elweb',
                    'SearchIdentity',
                    {
                        UGUEST: null,
                        identityID: null,
                        _UID: NextApiClient.getUID(),
                        nextbe: NextApiClient.backSite,
                        data: JSON.stringify(obj),
                        endpoint: this.preferences.config.extServices.customerSrv
                    },
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },
        /** Elkjop service upsertIdentity
         * @param obj
         * @returns {Promise<any>}
         * @private
         */
        _upsertIdentity (obj) {
            if(!obj.OperatingChain) {
                obj.OperatingChain = this.operatingChain;
            }

            if(!obj.SalesAreaCountry) {
                obj.SalesAreaCountry = this.countryCode;
            }

            if(!obj.EmployeeNumber) {
                obj.EmployeeNumber = this.user.userName.split('@')[0];
            }

            if(!obj.Store) {
                // this.customerData.Store = `${this.user.shop.cod} - ${this.user.shop.des}`;
                obj.Store = `${this.user.shop.cod}`;
            }

            return new Promise( (resolve, reject) => {
                NextApiClient.combase(
                    this.preferences.config.mediation,
                    'elweb',
                    'UpsertIdentity',
                    {
                        _UID: NextApiClient.getUID(),
                        nextbe: NextApiClient.backSite,
                        data: JSON.stringify(obj),
                        endpoint: this.preferences.config.extServices.customerSrv
                    },
                    res => {
                        if(res && res.Status && res.Status.toLowerCase() === 'ok')
                            resolve(res);
                        else
                            reject(res);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },
        selectCustomer(customer) {
            this.customerData = customer;
            if(!this.customerData.OperatingChain) {
                this.customerData.OperatingChain = this.operatingChain;
            }

            if(!this.customerData.SalesAreaCountry) {
                this.customerData.SalesAreaCountry = this.countryCode;
            }

            if(!this.customerData.EmployeeNumber) {
                this.customerData.EmployeeNumber = this.user.userName.split('@')[0];
            }

            if(!this.customerData.Store) {
                // this.customerData.Store = `${this.user.shop.cod} - ${this.user.shop.des}`;
                this.customerData.Store = `${this.user.shop.cod}`;
            }

            /*for(let k in customer) {
                if(customer.hasOwnProperty(k))
                    this.$set(this.customerData, k, customer[k]);
            }*/

            this.status = E_STEP.SAVE_CUSTOMER;
        },
        onShow() {
            this.status = E_STEP.MOBILE;
            this.errors = [];
            this.warnings = [];
            this.customersList = [];
            this.customerData = {};
            this.customerEmail = '';
            this.customerMobile = '';
            this.createUpdate = false;
            this.editMail = false;
        },
        skipToMail() {
            this.status = E_STEP.EMAIL;
            this.customersList = [];
            this.customerMobile = '';
        },
        skipToCustomer() {
            this.status = E_STEP.SAVE_CUSTOMER;
            this.customersList = [];
            this.customerMobile = '';
            this.customerEmail = '';
            if(!this.customerData.Address)
                this.customerData.Address = {};
        },
        checkMobilePlus(e) {
            this.errors = []

            if(e.target.value && e.target.value.charAt(0)) {
                if(e.target.value.charAt(0) !== '+') {
                    this.errors.push(this._trans('Invalid phone format'))
                }
                // else if(!e.target.value.match(/^(\+4[567])|^(\+358)/gi)) {
                else if(!/^(\+4[567])|^(\+358)/gi.test(e.target.value)) {
                    this.errors.push(this._trans('Invalid dialling codes, you can use (+45) (+46) (+47) (+358)'))
                }
                else
                    this.errors = []
            }
            else {
                this.errors = []
            }
        }
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/custom/epoq/dialogs/modalSetCustomer.vue